export interface RegistrarStatus {
  registrar: string;
  label: string;
  status: 'operational' | 'degraded' | 'unknown';
  lastRecordAt: string | null;
  recordsLast24h: number;
  tracked: boolean;
  hourlyActivity: number[];
}

export interface ServiceStatus {
  id: string;
  name: string;
  category: 'dns' | 'ssl' | 'hosting' | 'cdn' | 'email' | 'cloud';
  status: 'operational' | 'degraded' | 'outage' | 'unknown';
  description: string;
  statusPageUrl: string;
  lastCheckedAt: string;
}

export interface NewsItem {
  id: string;
  url: string;
  title: string;
  summary: string;
  source: string;
  publishedAt: string;
  savedAt: string;
}

export function timeAgo(iso: string): string {
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diffMs / 60_000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}
